import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Button } from '../Button';
import { useTranslate } from '../util';
import { StyledModalMessage } from './MessageModal.styled';
import { Modal, ModalBody, ModalFooter } from './Modal';
export function MessageModal(props) {
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(Modal, _extends({}, props, {
    onDismiss: props.onCloseSuccess
  }), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(StyledModalMessage, null, props.message)), !props.hideConfirm && /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button.Primary, {
    onClick: props.onCloseSuccess
  }, props.buttonText || t('citrix-ui:messageDialog.ok'))));
}